(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["animations"] && !Shopify.designMode) return;
  try {
    // Shared, ref-counted scroll lock so multiple overlays (menu drawer, cart drawer) can't
  // clobber each other's body-overflow reset — closing one no longer unlocks the page while
  // another is still open.
  if (!window.MetryScrollLock) {
    window.MetryScrollLock = (function () {
      var count = 0;
      return {
        lock: function () { count++; document.documentElement.style.overflow = 'hidden'; document.body.style.overflow = 'hidden'; },
        unlock: function () { count = Math.max(0, count - 1); if (count === 0) { document.documentElement.style.overflow = ''; document.body.style.overflow = ''; } }
      };
    })();
  }

  (function () {
    var root = document.documentElement;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function revealAll() {
      document.querySelectorAll('[data-reveal]').forEach(function (el) {
        el.classList.add('reveal-in');
      });
    }

    function initReveal() {
      var els = document.querySelectorAll('[data-reveal]');
      if (reduce || !('IntersectionObserver' in window)) {
        revealAll();
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('reveal-in');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
      els.forEach(function (el) { io.observe(el); });
    }

    function initImageFade() {
      document.querySelectorAll('img.lazy-fade').forEach(function (img) {
        if (img.complete && img.naturalWidth > 0) {
          img.classList.add('is-loaded');
        } else {
          img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
          img.addEventListener('error', function () { img.classList.add('is-loaded'); }, { once: true });
        }
      });
    }

    function start() { initReveal(); initImageFade(); }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["customer-styles"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gift-code')) {
    customElements.define('gift-code', class extends HTMLElement {
      connectedCallback() {
        const b = this.querySelector('[data-code]');
        if (b) b.addEventListener('click', () => {
          if (navigator.clipboard) navigator.clipboard.writeText(b.dataset.code);
          b.classList.add('is-copied'); setTimeout(() => b.classList.remove('is-copied'), 1500);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mt-button-motion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mt-button-motion')) {
    class MtButtonMotion extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.onPointerOver = this.onPointerOver.bind(this);
        this.addEventListener('pointerover', this.onPointerOver);
      }

      disconnectedCallback() {
        this.removeEventListener('pointerover', this.onPointerOver);
        this.initialized = false;
      }

      onPointerOver(event) {
        const control = event.target.closest('.mt-button-motion__control');
        if (!control || control.closest('mt-button-motion') !== this || control.contains(event.relatedTarget)) return;

        const bounds = control.getBoundingClientRect();
        this.dataset.mtButtonMotionEnter = event.clientX - bounds.left <= bounds.width / 2 ? 'left' : 'right';
      }
    }

    customElements.define('mt-button-motion', MtButtonMotion);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mx-salesiq-chat"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mx-salesiq-chat')) {
    customElements.define('mx-salesiq-chat', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.failed = false;
        this.ignoreClose = false;
        this.styleRequestId = 0;
        this.widgetStyleId = 'mx-salesiq-chat-visual-parity';
        this.removeAttribute('data-widget-style-state');
        this.statusNode = this.querySelector('.mx-salesiq-chat__message');
        this.widgetSource = this.dataset.widgetSource;
        this.setState('loading');

        if (!this.isAllowedSource(this.widgetSource)) {
          this.fail();
          return;
        }

        window.$zoho = window.$zoho || {};
        window.$zoho.salesiq = window.$zoho.salesiq || {};

        const salesiq = window.$zoho.salesiq;
        this.previousReady = salesiq.ready;
        this.readyCallback = () => {
          if (typeof this.previousReady === 'function' && this.previousReady !== this.readyCallback) {
            this.previousReady();
          }
          this.setWidgetLanguage(window.$zoho && window.$zoho.salesiq);
          if (this.isConnected && !this.failed) this.openChat();
        };
        salesiq.ready = this.readyCallback;

        this.timeout = window.setTimeout(() => this.fail(), 15000);

        if (salesiq.floatwindow && typeof salesiq.floatwindow.visible === 'function') {
          this.setWidgetLanguage(salesiq);
          this.openChat();
          return;
        }

        const existingScript = document.getElementById('zsiqscript')
          || document.querySelector('script[src*="salesiq.zohopublic.com/widget"]');

        if (existingScript) {
          this.scriptNode = existingScript;
          this.bindScriptFailure();
          return;
        }

        this.scriptNode = document.createElement('script');
        this.scriptNode.id = 'zsiqscript';
        this.scriptNode.src = this.widgetSource;
        this.scriptNode.defer = true;
        this.bindScriptFailure();
        document.body.appendChild(this.scriptNode);
      }

      disconnectedCallback() {
        this.initialized = false;
        this.ignoreClose = true;
        this.clearPendingWork();
        this.teardownWidgetStyle();
        this.unlockBackground();

        if (this.scriptNode && this.scriptErrorHandler) {
          this.scriptNode.removeEventListener('error', this.scriptErrorHandler);
        }

        const salesiq = window.$zoho && window.$zoho.salesiq;
        if (salesiq && salesiq.ready === this.readyCallback) salesiq.ready = this.previousReady;

        if (!document.querySelector('mx-salesiq-chat[data-state="loading"], mx-salesiq-chat[data-state="ready"]')) {
          document.documentElement.classList.remove('mx-salesiq-chat-page');
          this.hideChat();
        }
      }

      isAllowedSource(source) {
        try {
          const url = new URL(source);
          return url.protocol === 'https:'
            && url.hostname === 'salesiq.zohopublic.com'
            && url.pathname === '/widget'
            && url.searchParams.has('wc');
        } catch (error) {
          return false;
        }
      }

      bindScriptFailure() {
        this.scriptErrorHandler = () => this.fail();
        this.scriptNode.addEventListener('error', this.scriptErrorHandler, { once: true });
      }

      setWidgetLanguage(salesiq) {
        if (!salesiq || typeof salesiq.language !== 'function') return;

        try {
          salesiq.language('es');
        } catch (error) {
          // Preserve Zoho's configured fallback when its external runtime rejects an override.
        }
      }

      openChat() {
        const salesiq = window.$zoho && window.$zoho.salesiq;

        try {
          if (!this.closeRegistered && typeof salesiq.floatwindow.close === 'function') {
            this.closeHandler = () => this.handleClose();
            salesiq.floatwindow.close(this.closeHandler);
            this.closeRegistered = true;
          }
          if (salesiq.floatbutton && typeof salesiq.floatbutton.visible === 'function') {
            salesiq.floatbutton.visible('hide');
          }
          salesiq.floatwindow.visible('show');
        } catch (error) {
          this.fail();
          return;
        }

        this.waitForWidget();
      }

      waitForWidget() {
        if (this.finishIfWidgetExists()) return;

        this.observer = new MutationObserver(() => this.finishIfWidgetExists());
        this.observer.observe(document.body, { childList: true, subtree: true });
      }

      finishIfWidgetExists() {
        const wrapper = document.getElementById('zsiq_chat_wrap');
        if (!wrapper) return false;

        const frame = wrapper.querySelector('iframe');
        if (!frame) return false;
        if (frame && !frame.title) frame.title = this.dataset.frameTitle;
        this.bindWidgetFrame(wrapper, frame);
        this.clearPendingWork();
        this.setState('ready');
        return true;
      }

      bindWidgetFrame(wrapper, frame) {
        if (this.frameNode !== frame) {
          if (this.frameNode && this.frameLoadHandler) {
            this.frameNode.removeEventListener('load', this.frameLoadHandler);
            this.frameNode.style.removeProperty('visibility');
          }

          this.frameNode = frame;
          this.frameLoadHandler = () => {
            frame.style.setProperty('visibility', 'hidden', 'important');
            this.scheduleWidgetStyle(frame);
          };
          frame.addEventListener('load', this.frameLoadHandler);
          frame.style.setProperty('visibility', 'hidden', 'important');
        }

        if (!this.frameObserver) {
          this.frameObserver = new MutationObserver(() => {
            const currentFrame = wrapper.querySelector('iframe');
            if (currentFrame && currentFrame !== this.frameNode) {
              if (!currentFrame.title) currentFrame.title = this.dataset.frameTitle;
              this.bindWidgetFrame(wrapper, currentFrame);
            }
          });
          this.frameObserver.observe(wrapper, { childList: true, subtree: true });
        }

        this.scheduleWidgetStyle(frame);
      }

      scheduleWidgetStyle(frame) {
        const requestId = ++this.styleRequestId;
        let attempt = 0;
        window.clearTimeout(this.styleRetryTimer);

        const apply = () => {
          if (!this.isConnected || requestId !== this.styleRequestId || frame !== this.frameNode) return;

          const result = this.applyWidgetStyle(frame);
          if (result === 'applied') {
            this.finishWidgetStyle(frame, 'applied');
            return;
          }

          if (result === 'blocked' || attempt >= 20) {
            this.finishWidgetStyle(frame, 'native');
            return;
          }

          attempt += 1;
          this.styleRetryTimer = window.setTimeout(apply, 100);
        };

        apply();
      }

      applyWidgetStyle(frame) {
        let frameDocument;
        try {
          frameDocument = frame.contentDocument || (frame.contentWindow && frame.contentWindow.document);
        } catch (error) {
          return 'blocked';
        }

        if (!frameDocument) return 'blocked';
        if (!frameDocument.head) return 'pending';

        let style = frameDocument.getElementById(this.widgetStyleId);
        if (!style) {
          style = frameDocument.createElement('style');
          style.id = this.widgetStyleId;
          style.textContent = this.getWidgetStyleText();
          frameDocument.head.appendChild(style);
        }

        this.observeWidgetStyle(frameDocument, frame);
        this.observeWidgetText(frameDocument);
        return 'applied';
      }

      localizeWidgetText(frameDocument) {
        const label = Array.from(frameDocument.querySelectorAll('.home-widget > .p10.bdr-btm-E.pL15.flexC.fw600'))
          .find((node) => node.textContent.trim() === 'Previous conversations');

        if (!label) return false;

        for (const node of label.childNodes) {
          const value = node.nodeValue || '';
          if (node.nodeType !== 3 || !value.includes('Previous conversations')) continue;
          node.nodeValue = node.nodeValue.replace('Previous conversations', 'Conversaciones anteriores');
          return true;
        }

        return false;
      }

      observeWidgetText(frameDocument) {
        if (this.innerTextDocument === frameDocument && this.innerTextObserver) return;
        if (this.innerTextObserver) this.innerTextObserver.disconnect();

        this.innerTextDocument = frameDocument;
        const localize = () => {
          if (!this.localizeWidgetText(frameDocument)) return;
          if (this.innerTextObserver) this.innerTextObserver.disconnect();
          this.innerTextObserver = null;
          this.innerTextDocument = null;
        };

        localize();
        if (!this.innerTextDocument) return;

        this.innerTextObserver = new MutationObserver(localize);
        this.innerTextObserver.observe(frameDocument.documentElement, { childList: true, subtree: true });
      }

      observeWidgetStyle(frameDocument, frame) {
        if (this.innerStyleDocument === frameDocument && this.innerStyleObserver) return;
        if (this.innerStyleObserver) this.innerStyleObserver.disconnect();

        this.innerStyleDocument = frameDocument;
        this.innerStyleObserver = new MutationObserver(() => {
          if (!frameDocument.getElementById(this.widgetStyleId)) this.scheduleWidgetStyle(frame);
        });
        this.innerStyleObserver.observe(frameDocument.head, { childList: true });
      }

      finishWidgetStyle(frame, state) {
        window.clearTimeout(this.styleRetryTimer);
        this.styleRetryTimer = null;
        frame.style.removeProperty('visibility');
        this.dataset.widgetStyleState = state;
      }

      getWidgetStyleText() {
        return `
          .home-option-wrap,
          .home-icon-optns {
            border: 1px solid #e0e0e0 !important;
            border-radius: 10px !important;
            background: #fff !important;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08) !important;
          }

          .siqcw-tab-cont,
          .siqcw-tab-par,
          .footer-tab,
          .footer-sub-tab,
          .footer-icon-div,
          .tab-footer-sel,
          .siqcw-tab-cont * {
            color: #333 !important;
            --siqcw-custom-text-color: #333 !important;
            --siqcw-custom-icon-color: #333 !important;
            --siqcw-custom-bg-color: #f5f5f5 !important;
            --siqcw-custom-border-color: #d0d0d0 !important;
          }

          .siqcw-tab-par {
            border-top: 1px solid #e0e0e0 !important;
            background: #f8f8f8 !important;
          }

          .siqico-home,
          .siqico-chat-start,
          .siqico-chat-queue,
          .home-icon-optns svg,
          .home-icon-optns path {
            color: #333 !important;
            fill: #333 !important;
          }

          .footer-icon-div svg,
          .footer-icon-div path,
          .footer-tab svg,
          .footer-tab path {
            fill: #333 !important;
            stroke: #333 !important;
          }

          .siqcw-header,
          .seasonal-header-bg,
          .siqcw-header-detail {
            background: #f5f5f5 !important;
            color: #333 !important;
            --siqcw-custom-text-color: #333 !important;
            --siqcw-custom-icon-color: #333 !important;
            --siqcw-custom-bg-color: #f5f5f5 !important;
          }

          .siqcw-header .header-title,
          .siqcw-header .font16,
          .siqcw-header .font16.fw600.elips,
          .header-title,
          .font16.fw600.elips {
            color: #333 !important;
          }

          .siqcw-header .siqico-larrow,
          .left-arrow-icon {
            color: #333 !important;
          }

          .siqcw-header .header-title {
            width: auto !important;
            min-width: 0 !important;
            max-width: none !important;
            flex: 1 1 auto !important;
          }

          .siqcw-header .header-title .font16.fw600.elips {
            overflow: visible !important;
            color: #333 !important;
            line-height: 1.4 !important;
            text-overflow: clip !important;
            white-space: normal !important;
          }

          .siqcw-newchat.siqcw-btn {
            border: 1px solid #e0e0e0 !important;
            border-radius: 8px !important;
            background: #fff !important;
            color: #333 !important;
            --siqcw-custom-text-color: #333 !important;
            --siqcw-custom-bg-color: #fff !important;
          }

          .siqcw-newchat .elips,
          .siqcw-newchat .siqico-chat-start {
            color: #333 !important;
          }

          .brand-detl-wrap {
            z-index: 5 !important;
          }
        `;
      }

      teardownWidgetStyle() {
        this.styleRequestId += 1;
        window.clearTimeout(this.styleRetryTimer);
        this.styleRetryTimer = null;

        if (this.frameObserver) this.frameObserver.disconnect();
        if (this.innerStyleObserver) this.innerStyleObserver.disconnect();
        if (this.innerTextObserver) this.innerTextObserver.disconnect();
        this.frameObserver = null;
        this.innerStyleObserver = null;
        this.innerStyleDocument = null;
        this.innerTextObserver = null;
        this.innerTextDocument = null;

        if (this.frameNode && this.frameLoadHandler) {
          this.frameNode.removeEventListener('load', this.frameLoadHandler);
        }

        if (this.frameNode) {
          this.frameNode.style.removeProperty('visibility');
          try {
            const frameDocument = this.frameNode.contentDocument
              || (this.frameNode.contentWindow && this.frameNode.contentWindow.document);
            const style = frameDocument && frameDocument.getElementById(this.widgetStyleId);
            if (style) style.remove();
          } catch (error) {
            this.dataset.widgetStyleState = 'native';
          }
        }

        this.frameNode = null;
        this.frameLoadHandler = null;
      }

      fail() {
        if (!this.isConnected || this.failed) return;

        this.failed = true;
        this.ignoreClose = true;
        this.clearPendingWork();
        this.teardownWidgetStyle();
        this.hideChat();
        if (this.statusNode) this.statusNode.textContent = this.dataset.unavailableText;
        this.setState('error');
      }

      handleClose() {
        if (!this.isConnected || this.ignoreClose) return;

        let referrer;
        try {
          referrer = document.referrer ? new URL(document.referrer) : null;
        } catch (error) {
          referrer = null;
        }

        const sensitivePath = referrer
          ? /^(\/checkouts|\/cart|\/account|\/pages\/chat)(\/|$)/i.test(referrer.pathname)
          : false;

        if (referrer && referrer.host === window.location.host && !sensitivePath && window.history.length > 1) {
          window.history.back();
        } else {
          window.location.assign('/');
        }
      }

      hideChat() {
        const salesiq = window.$zoho && window.$zoho.salesiq;
        try {
          if (salesiq && salesiq.floatwindow && typeof salesiq.floatwindow.visible === 'function') {
            salesiq.floatwindow.visible('hide');
          }
          if (salesiq && salesiq.floatbutton && typeof salesiq.floatbutton.visible === 'function') {
            salesiq.floatbutton.visible('hide');
          }
        } catch (error) {
          return;
        }
      }

      clearPendingWork() {
        window.clearTimeout(this.timeout);
        if (this.observer) this.observer.disconnect();
        this.observer = null;
      }

      lockBackground() {
        if (this.inertedElements) return;

        const candidates = [
          ...document.querySelectorAll('body > .skip-to-content, body > .shopify-section-group-header-group, body > .shopify-section-group-footer-group, body > #shopify-section-cart-drawer'),
          ...Array.from(document.querySelectorAll('#MainContent > .shopify-section')).filter((element) => !element.contains(this))
        ];

        this.inertedElements = candidates.map((element) => ({ element, wasInert: element.inert }));
        this.inertedElements.forEach(({ element }) => { element.inert = true; });
      }

      unlockBackground() {
        if (!this.inertedElements) return;
        this.inertedElements.forEach(({ element, wasInert }) => { element.inert = wasInert; });
        this.inertedElements = null;
      }

      setState(state) {
        this.dataset.state = state;
        this.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');

        const status = this.querySelector('.mx-salesiq-chat__status');
        if (status) status.hidden = state === 'ready';

        if (state === 'loading' || state === 'ready') {
          this.lockBackground();
          document.documentElement.classList.add('mx-salesiq-chat-page');
        } else if (!document.querySelector('mx-salesiq-chat[data-state="loading"], mx-salesiq-chat[data-state="ready"]')) {
          this.unlockBackground();
          document.documentElement.classList.remove('mx-salesiq-chat-page');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
